import React from 'react';

import {
  Dialog, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateTimeFormatter, subjectFormatter, subjectFormatterForNotification,
} from '../../../utils/formatters';

export default function NotificationPopUp(props) {
  const {
    onClose = () => {}, current = {},
  } = props;

  const { created_at, data = {} } = current;

  const renderMessage = message => {
    if (!message) return null;

    if (Array.isArray(message)) {
      return message.map((item, idx) => <div key={idx}>{item}</div>);
    }

    return message;
  };

  return (
    <Dialog
      className="pnp-popup-view"
      onClose={onClose}
      open
    >
      <DialogTitle header="Просмотр бланка уведомления" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="pnp-view-content">
        <div className="pnp-view-table">
          <Row className="row-cols-2">
            <Col className="pnp-view-label" columns={4}>Тип уведомления</Col>
            <Col className="pnp-view-value" columns={8}>{current.type_label || ''}</Col>
          </Row>
          {/* <Row className="row-cols-2"> */}
          {/*  <Col className="pnp-view-label" columns={4}>Текст</Col> */}
          {/*  <Col className="pnp-view-message" columns={8}>{current.message || ''}</Col> */}
          {/* </Row> */}
          <Row className="row-cols-2">
            <Col className="pnp-view-label" columns={4}>Объект</Col>
            <Col className="pnp-view-value column" columns={8}>
              {
                (data?.subjects || []).map(subject => (
                  subjectFormatterForNotification(subject)
                ))
              }
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="pnp-view-label" columns={4}>Дата создания</Col>
            <Col className="pnp-view-value" columns={8}>{dateTimeFormatter(created_at)}</Col>
          </Row>
        </div>
        <div className="mt-4 mb-3">{renderMessage(current.message)}</div>
      </DialogContent>
    </Dialog>
  );
}
